import React, { Fragment, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, MenuItem } from "react-pro-sidebar";
import { IconButton, Grid, Stack, Box, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import EditNote from "@mui/icons-material/Edit";
import Collapse from "@mui/material/Collapse";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CloseIcon from "@mui/icons-material/Close";
import TkTitle from "../../atoms/TkTitle";
import TkButton from "../../atoms/TkButton";
import { TkMenuProps } from "../../../type/componentsType/TkMenu";
import {
  facilitiesAndOtherProcedures,
  staffAndPaymentProcedures,
  standardMenu,
} from "./parts";
import "./_style.scss";
import SCRC090002 from "../../../pages/SCRC090002";
import { BusinessContext } from "../../../context/businessContext";
import { GlobalContext } from "../../../context/globalContext";
import { useConcatRoutes } from "../../../routes/router";
import _ from "lodash";

/**
 * システムメニュー
 * ヘッダーに表示するハンバーガーメニュー
 * @return TkMenu
 */
export const TkMenu: React.FC<TkMenuProps> = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [threadOpen, setThreadOpen] = useState(false);

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBussinessState } =
    useContext(BusinessContext);

  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (page: any, pageObj: any) => {
    const { path, param, setBusinessType } = pageObj;

    let wantToSetInRouterList = [
      {
        href: "/SCRC020001",
        title: "共済契約者ホーム",
      },
    ];

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const routers = useConcatRoutes();

    const router = routers.find((r) => r.path === path);
    const newItem = _.cloneDeep(router);

    wantToSetInRouterList[1] = {
      title: newItem?.meta?.title as string,
      href: path as string,
    };

    // 遷移前と遷移後の画面IDを比較
    const isSamePage = location.pathname === path;

    // 遷移前の画面ID = 遷移後の画面ID　かつ　持ち回り情報.業務タイプ = "JOB-15"
    const shouldSkipSetBusinessState =
      isSamePage && businessState.common?.businessType === "JOB-15";

    if (page !== "チャットボットに質問する" && !shouldSkipSetBusinessState) {
      setBussinessState({
        common: {
          businessType: setBusinessType ?? "",
        },
      });
    }

    navigate(path, { state: { ...param, wantToSetInRouterList } });

    setIsOpen(false);
    setState({ ...state, chatOpen: page === "チャットボットに質問する" });
    setThreadOpen(page === "機構職員に連絡する");
  };

  const renderMenuItems = (menuItems: any[], noBorder?: boolean) => {
    return menuItems.map((menu, key) => (
      <Fragment key={key}>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <Box className={`top-hamMenu-text ${noBorder && "hideBorder"}`}>
            {menu.icon}
            <Typography>{menu.name}</Typography>
          </Box>
        </Collapse>
        {menu.options.map((submenu: any, index: any) => (
          <MenuItem
            key={index}
            className={`sub-hamMenu-text ${
              location.pathname === submenu.path ? "active" : ""
            }`}
            data-testid="tkMenuLink"
            component={
              <Box onClick={() => handleClick(submenu.name, submenu)} />
            }
            icon={submenu.icon}
            title={submenu.name}
            disabled={
              !state.authInfo?.contractApprovalDate &&
              !(
                submenu.name === "共済契約者ホーム" ||
                submenu.name === "チャットボットに質問する" ||
                submenu.name === "パスワード変更"
              )
            }
          >
            <Typography>{submenu.name}</Typography>
          </MenuItem>
        ))}
      </Fragment>
    ));
  };

  return (
    <>
      <IconButton
        size="large"
        edge="start"
        title="システムメニュー一覧はこちら"
        onClick={() => setIsOpen(true)}
        data-testid="tkMenuIconButton"
      >
        <MenuOutlinedIcon />
      </IconButton>
      <Modal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="tkMenuModal"
      >
        <Grid container spacing={1} className="tkMenuStyle">
          <Grid item xs={12} className="tkMenuHeader">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <TkTitle>退職手当共済システムメニュー</TkTitle>
              <TkButton
                variant="contained"
                onClick={() => setIsOpen(false)}
                size="small"
              >
                <CloseIcon />
                <Typography className="closeButtonText">閉じる</Typography>
              </TkButton>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={4} pr={1} pl={1}>
            <Menu>{renderMenuItems(standardMenu)}</Menu>
          </Grid>

          <Grid item xs={12} sm={8} pr={1}>
            <Box className="top-hamMenu-text" borderBottom={1}>
              <EditNote />
              <Typography>お手続き</Typography>
            </Box>
            <Grid container>
              <Grid item xs={12} sm={6} pr={1}>
                <Menu>{renderMenuItems(staffAndPaymentProcedures, true)}</Menu>
              </Grid>

              <Grid item xs={12} sm={6} pr={1}>
                <Menu>
                  {renderMenuItems(facilitiesAndOtherProcedures, true)}
                </Menu>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>

      <SCRC090002 open={threadOpen} onClose={() => setThreadOpen(false)} />
    </>
  );
};

export default TkMenu;
